import { ApiURLs } from "../../../constant/ApiUrls";
import { fetchData } from "../../../services/api";

export const billingSummaryRequest = () => {
  return async (dispatch) => {
    dispatch({ type: "GET_BILLING_REQUEST" });
    try {
      const res = await fetchData(ApiURLs.BILLING_SUMMARY);
      if (res.status === 1) {
        dispatch({ type: "GET_BILLING_SUMMARY_SUCCESS", payload: res.data || null });
      } else {
        dispatch({ type: "GET_BILLING_FAILED" });
      }
    } catch (error) {
      dispatch({ type: "GET_BILLING_FAILED" });
      console.log("error while getting billing summary", error);
    }
  };
};

export const billingSubscriptionsRequest = (page = 1, pageSize = 25, search = "", unbilled = false) => {
  return async (dispatch) => {
    dispatch({ type: "GET_BILLING_REQUEST" });
    try {
      const url =
        `${ApiURLs.BILLING_SUBSCRIPTIONS}?limit=${pageSize}&offset=${page}` +
        `&search=${encodeURIComponent(search)}${unbilled ? "&unbilled=1" : ""}`;
      const res = await fetchData(url);
      if (res.status === 1) {
        dispatch({
          type: "GET_BILLING_SUBSCRIPTIONS_SUCCESS",
          payload: res.data.result || [],
          total: res.data.total || 0,
        });
      } else {
        dispatch({ type: "GET_BILLING_FAILED" });
      }
    } catch (error) {
      dispatch({ type: "GET_BILLING_FAILED" });
      console.log("error while getting subscriptions", error);
    }
  };
};

export const billingPaymentsRequest = (page = 1, pageSize = 25, search = "") => {
  return async (dispatch) => {
    dispatch({ type: "GET_BILLING_REQUEST" });
    try {
      const url = `${ApiURLs.BILLING_PAYMENTS}?limit=${pageSize}&offset=${page}&search=${encodeURIComponent(search)}`;
      const res = await fetchData(url);
      if (res.status === 1) {
        dispatch({
          type: "GET_BILLING_PAYMENTS_SUCCESS",
          payload: res.data.result || [],
          total: res.data.total || 0,
        });
      } else {
        dispatch({ type: "GET_BILLING_FAILED" });
      }
    } catch (error) {
      dispatch({ type: "GET_BILLING_FAILED" });
      console.log("error while getting payments", error);
    }
  };
};
